import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { environment } from "~env";
import { DynamicQuestion, WorkHour } from "./inscription.model";

@Injectable({
  providedIn: 'root',
})
export class InscriptionQueryService {

  private REFERENCE_TABLE_QUERY_API = environment.referenceTableQueryApi;
  private PROJECTION_QUERY_API = environment.projectionQueryApi;

  constructor(private http: HttpClient) { }

  getInscriptionQuestions(year: number): Observable<DynamicQuestion[]> {
    return this.http.get<DynamicQuestion[]>(`${this.REFERENCE_TABLE_QUERY_API}/annualRegistrationQuestions?$filter=Year eq ${year}&$orderby=QuestionNumber`)
      .pipe(
        map(res => res['value']?.map(item => this.parseDynamicQuestion(item)))
      );
  }

  private parseDynamicQuestion(item: any): DynamicQuestion {
    return {
      id: item.Id,
      questionNumber: item.QuestionNumber,
      year: item.Year,
      code: item.Code,
      dataType: item.DataType,
      editLabel: {
        fr: item.EditLabel.Fr,
        en: item.EditLabel.En,
      },
      isActive: item.IsActive,
      isAdhocQuestion: item.IsAdhocQuestion,
      isRequired: item.IsRequired,
      section: item.Section,
      sequenceNumber: item.SequenceNumber,
      summaryLabel: {
        fr: item.SummaryLabel.Fr,
        en: item.SummaryLabel.En,
      },
    }
  }

  getPreviousYearAnswer(memberId: string, year: number) {
    const URL = `${this.PROJECTION_QUERY_API}/memberAnnualRegistrationAnswers?$filter=Year eq ${Number(year) - 1}&$orderby=QuestionNumber`;
    return this.http.get<any>(URL).pipe(
      map(res => res['value'])
    )
  }
  getMemberEmail(memberId: string): Observable<string> {
    const URL = `${this.PROJECTION_QUERY_API}/fullMembers?$select=Email&?$filter=Id eq ${memberId}`;
    return this.http.get<any>(URL).pipe(
      map(res => res['value'][0].Email)
    );
  }

  getMemberIdByPermitNumber(permitNumber: string): Observable<string> {
    const URL = `${this.PROJECTION_QUERY_API}/fullMembers?$select=Id&?$filter=PermitNumber eq ${permitNumber}`;
    return this.http.get<any>(URL).pipe(
      map(res => res['value'][0].Id)
    );
  }

  getMemberWorkHours(memberId: string): Observable<WorkHour[]> {
    return this.http.get(`${this.PROJECTION_QUERY_API}/memberWorkHours?$filter=MemberId eq ${memberId}`)
      .pipe(
        map(res => res['value'])
      );
  }
}